import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import { Button } from '@mui/material';

interface CreateButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * 新規作成ボタンコンポーネント
 */
export const CreateButton = ({ onClick, label }: CreateButtonProps) => {
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<AddCircleOutlinedIcon />}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

